import { addDoc, collection } from 'firebase/firestore';
import { encryptNIP, getUrlParameter } from '../../general/functions';
import { dbFirestore } from '../../general/firebase';

/** Save to Firebase */
const processFirebase = async function (mentions, actions) {
  if (!['mainApplicationUpdated', 'applicationApplied', 'applicationPrioritized'].includes(actions)) {
    if (mentions === '' || mentions === null) {
      throw new Error('Empty sets');
    }

    if (mentions.targetNIP === '' || mentions.targetNIP === null) {
      throw new Error('Empty staff');
    }

    const notifyPath = `User/${encryptNIP(mentions.targetNIP)}/Notification`;

    const docRef = await addDoc(collection(dbFirestore, notifyPath), {
      type: actions,
      targetNIP: mentions.targetNIP,
      creatorName: mentions.creatorName,
      targetName: mentions.targetName,
      link: 'leads/details?id=' + getUrlParameter('id'),
      isRead: false,
      creator: mentions.creatorNIP,
      created: Date.now(),
      // others: mentions.others === null ? null : mentions.others,
    });

    return docRef.id;
  } else {
    return true;
  }
};

const calculateApplicationDocuments = function (btn) {
  const curObj = btn.parents('form');

  const objFile = {
    id: curObj.attr('data-application-id'),
    requiredFiles: 0,
    currentFiles: 0,
  };

  const curFiles = curObj.find(`.application-file-container[data-fillable="${curGROUPS}"]`);

  for (let i = 0; i < curFiles.length; i++) {
    const indFile = $(curFiles[i]);
    const uploadedFiles = indFile.find('.application-file-list .files-separator');

    if (indFile.attr('data-fillable') === curGROUPS) {
      objFile.requiredFiles++;
    }

    if (uploadedFiles.length != 0) {
      objFile.currentFiles++;
    }
  }

  const curStatus = curObj.find('[name="documentStatus"]');

  if (curStatus.val() === 'INCOMPLETE') {
    if (objFile.currentFiles === objFile.requiredFiles) {
      curStatus.val('COMPLETE');
    }
  }

  return objFile;
};

const adjustBar = function () {
  const items = $('.steps').length;
  const elHeight = $('.steps').height() / 2; //Division by 2 because each pseudo which is skewed is only 50% of its parent.
  const skewOffset = Math.tan(45 * (Math.PI / 180)) * elHeight;
  const reduction = skewOffset + (items - 1) * 4;
  const leftOffset = $('.steps').css('left').replace('px', '');
  const factor = leftOffset * -1 - 2;

  $('.steps').css({
    width: '-webkit-calc((100% + 4px - ' + reduction + 'px)/' + items + ')',
    width: 'calc((100% + 4px - ' + reduction + 'px)/' + items + ')',
  }); // 4px for borders on either side

  $('.steps:first-child, .steps:last-child').css({
    width: '-webkit-calc((100% + 4px - ' + reduction + 'px)/' + items + ' + ' + factor + 'px)',
    width: 'calc((100% + 4px - ' + reduction + 'px)/' + items + ' + ' + factor + 'px)',
  }); // 26px because to make up for the left offset. Size of last-child is also increased to avoid the skewed area on right being shown

  $('.steps span').css('padding-left', skewOffset + 15 + 'px');

  $('.steps:first-child span, .steps:last-child span').css({
    width: '-webkit-calc(100% - ' + factor + 'px)',
    width: 'calc(100% - ' + factor + 'px)',
  });
};

/** Initialize Forms Validation */
const applicationDueValidation =
  $('#formApplicationDueDate').length > 0
    ? FormValidation.formValidation(document.getElementById('formApplicationDueDate'), {
      fields: {
        applicationDueDate: {
          validators: {
            notEmpty: {
              message: 'Due date cannot be empty',
            },
          },
        },
      },
      plugins: {
        trigger: new FormValidation.plugins.Trigger(),
        excluded: new FormValidation.plugins.Excluded(),
        bootstrap: new FormValidation.plugins.Bootstrap(),
      },
    })
    : null;
/** EoL Initialize Forms Validation */

const cleaveConfig = {
  numeral: true,
  numeralThousandsGroupStyle: 'thousand',
  numeralDecimalMark: ',',
  delimiter: '.',
  numeralDecimalScale: 2,
  numeralIntegerScale: 15
}

export { adjustBar, applicationDueValidation, processFirebase, calculateApplicationDocuments, cleaveConfig };
